import React from "react";
import { Link } from "react-router-dom";
import back from "../assets/home2back.webp";
import tick from "../assets/service-images/tick.png";
import image1 from "../assets/service-images/Line001.png";
import image from "../assets/scopes_home.webp";
import image2 from "../assets/homes/img1.svg";
import image3 from "../assets/homes/img2.svg";
import image4 from "../assets/homes/img3.svg";
import image5 from "../assets/homes/img4.svg";
import image6 from "../assets/homes/img5.svg";

const SnBuddy = () => {
  return (
    <>
      {/* Section 1 */}
      <div
        className="bg-cover bg-center bg-no-repeat min-h-[502px] flex flex-col gap-8 justify-center items-center px-6 py-16 md:px-8 lg:px-16"
        style={{ backgroundImage: `url(${back})` }}
      >
        <div className="flex flex-col items-center justify-center">
          <span data-aos="fade-down" className="flex items-center span_newthunders">Introducing SN Resume Buddy <img
            src={require("../assets/thunder.svg").default}
            alt="thunder"/></span>
          <h1
            data-aos="fade-down"
            className="text-3xl line_hightheading md:text-3xl lg:text-3xl/5 xl:text-5xl font-bold text-white w-full md:w-2/3 lg:w-5/10 text-center"
          >
            The Smartest Way to Supercharge Your ServiceNow Resume
          </h1>
        </div>
      </div>
      <div className="flex flex-col justify-start px-4 py-8 md:py-12 lg:py-16 bg-[#fff]">
        <div className="relative">
          <div className="text-center mb-10 px-6" data-aos="fade-up">
            <h1
              className="text-black mb-6 flex justify-center items-center font-semibold text-2xl lg:text-3xl"
            >
              What is SN Resume Buddy? <img className="w-[50px]" src={require("../assets/homes/header_siders.svg").default} alt="thunder"/>
            </h1>
            <span className="font-[400] md:text-lg">
              SN Resume Buddy is an AI-powered assistant crafted specifically to help ServiceNow professionals build laser-focused, high-impact resumes that get noticed by recruiters and hiring managers.
            </span>
            <h1
              className="text-black mt-10 mb-4 flex justify-center items-center font-semibold text-2xl lg:text-3xl"
            >
              Whether you're a:
            </h1>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 px-6 gap-5 py-5" data-aos="fade-up">
              <div className="flex flex-col items-center main_assisthome">
                <img src={require("../assets/homes/icon1.svg").default} alt=""/>
                <p>ServiceNow Developer</p>
              </div>
              <div className="flex flex-col items-center main_assisthome">
                <img src={require("../assets/homes/icon2.svg").default} alt=""/>
                <p>ITSM Consultant</p>
              </div>
              <div className="flex flex-col items-center main_assisthome">
                <img src={require("../assets/homes/icon3.svg").default} alt=""/>
                <p>Platform Architect</p>
              </div>
              <div className="flex flex-col items-center main_assisthome">
                <img src={require("../assets/homes/icon4.svg").default} alt=""/>
                <p>Admin or BA</p>
              </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-start py-8 md:py-12 md:px-4 lg:py-16 bg-[#F6F6F6]" data-aos="fade-up">
        <div className="flex flex-col justify-start px-6 smaller_paddingsset">
          <h2 className="text-2xl font-bold text-[#1A5298] mb-8">What can SN Resume Buddy Do for you?</h2>
          
          <h5 className="text-[18px] md:items-center items-start flex font-[500] text-[#000] mb-2"><img className="mr-2 w-[18px] md:mt-0 mt-1" src={require("../assets/check_green.svg").default} alt=""/> Turn technical tasks into resume gold</h5>
          <small className="text-[#7A7979] text-[16px] font-[400]">Example:</small>
          <small className="text-[#7A7979] text-[16px] font-[400] mb-2"><b className="text-[#000] font-[500]">Before:</b> “Worked on Incident Management”</small>
          <small className="text-[#7A7979] text-[16px] font-[400] mb-5"><b className="text-[#000] font-[500]">After:</b> “Configured and automated Incident Management in ServiceNow using Predictive Intelligence Workbench, reducing triage time by 40%.”</small>
          <h5 className="text-[18px] md:items-center items-start flex font-[500] text-[#000] mb-2"><img className="mr-2 w-[18px] md:mt-0 mt-1" src={require("../assets/check_green.svg").default} alt=""/> Optimize resumes for ATS (Applicant Tracking Systems)</h5>
          <small className="text-[#7A7979] text-[16px] font-[400] mb-5">My resume points are filled with keywords that match real job descriptions and platform features — so your resume passes filters.</small>
          <h5 className="text-[18px] md:items-center items-start flex font-[500] text-[#000] mb-2"><img className="mr-2 w-[18px] md:mt-0 mt-1" src={require("../assets/check_green.svg").default} alt=""/> Highlight measurable impact</h5>
          <small className="text-[#7A7979] text-[16px] font-[400] mb-5">Recruiters love numbers. I help you quantify improvements in uptime, SLA, MTTR, resolution time, and more.</small>
          <h5 className="text-[18px] md:items-center items-start flex font-[500] text-[#000] mb-2"><img className="mr-2 w-[18px] md:mt-0 mt-1" src={require("../assets/check_green.svg").default} alt=""/> Support your full ServiceNow journey</h5>
          <small className="text-[#7A7979] text-[16px] font-[400]">From <b className="text-[#000] font-[500]">Service Catalog setup</b> to <b className="text-[#000] font-[500]">Edge Encryption</b>, from <b className="text-[#000] font-[500]">Virtual Agent configuration</b> to <b className="text-[#000] font-[500]">Major Incident AI classification</b> — I make sure every module shines on your resume.</small>
        </div>
      </div>
      {/* Section 2 */}
      <div className="flex flex-col justify-start px-4 py-8 md:py-12 lg:py-16 bg-[#F0FAFF]">
        <div className="relative">
          <div className="text-center mb-10 px-6">
            <h1
              className="text-black font-semibold text-2xl lg:text-3xl"
              data-aos="fade-up"
            >
              Sample Resume Points I Generate
            </h1>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 px-6 gap-3 py-5">
            {[
              {
                img: image2,
                title: "AI/ML in ITSM",
                desc: "Integrated Predictive Intelligence Workbench for Change Requests, enabling proactive risk analysis and reducing change failure rates by 25%.",
              },
              {
                img: image3,
                title: "Integrations",
                desc: "Built real-time dashboards for Change and Problem Management using ITSM Success Dashboard, improving executive visibility into SLA trends.",
              },
              {
                img: image4,
                title: "ServiceNow Upgrades",
                desc: "Led the Yokohama ITSM upgrade with zero downtime, aligning platform capabilities with latest best practices and security standards.",
              },
            ].map((service, index) => (
              <div
                data-aos="fade-up"
                key={index}
                className="sec3 flex flex-col items-center text-center mt-20 transform transition-all duration-300 hover:scale-105 hover:shadow-xl"
              >
                <div className="w-full bg-gradient-to-r from-[#981A59] to-[#124B6A] h-[10px]"></div>
                <div className="flex flex-col items-center rounded border bg-[#FFFFFF] flex-1 w-full hover:transition-all duration-300">
                  <img
                    className="-mt-10 transform transition-transform duration-300"
                    src={service.img}
                    alt={service.title}
                  />
                  <h3 className="sec3title text-lg font-semibold mt-4 text-[#000]">
                    {service.title}
                  </h3>
                  <p className="text-sm text-black mt-2 flex-grow lg:w-[300px] mb-10">
                    {service.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 px-6 py-5">
            {[
              {
                img: image5,
                title: "Mobile & Portal Experiences",
                desc: "Customized the Employee Center Portal and Mobile Agent experience, increasing self-service adoption by 50% across iOS and Android platforms.",
              },
              {
                img: image6,
                title: "Security & Compliance",
                desc: "Configured Edge Encryption for ITSM Virtual Agent workflows, ensuring GDPR and enterprise security compliance.",
              },
            ].map((service, index) => (
              <div
                data-aos="fade-up"
                key={index}
                className="sec3 flex flex-col items-center text-center mt-20 transform transition-all duration-300 hover:scale-105 hover:shadow-xl"
              >
                <div className="w-full bg-gradient-to-r from-[#981A59] to-[#124B6A] h-[10px]"></div>
                <div className="flex flex-col items-center rounded border bg-[#FFFFFF] flex-1 w-full hover:transition-all duration-300">
                  <img
                    className="-mt-10 transform transition-transform duration-300"
                    src={service.img}
                    alt={service.title}
                  />
                  <h3 className="sec3title text-lg font-semibold mt-4 text-[#000]">
                    {service.title}
                  </h3>
                  <p className="text-sm text-black mt-2 flex-grow lg:w-[80%] mb-10">
                    {service.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      {/* Section 3 */}
      <div className="flex flex-col lg:flex-row items-center justify-between px-6 py-16 md:px-8 lg:px-16 gap-10">
        <div className="flex flex-col items-start w-full lg:w-1/2">
          <img
            src={image1}
            alt="Illustration"
            className="max-w-xs md:max-w-sm"
            data-aos="fade-up"
            data-aos-delay="300"
          />
          <h1
            className="text-black font-semibold text-2xl md:text-2xl mt-5 w-full lg:w-[600px]"
            data-aos="fade-up"
            data-aos-delay="300"
          >
             Who Uses Me?
          </h1>
          <ul
            className="mt-5 space-y-3"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            {[
              "ServiceNow professionals preparing for a career switch",
              "Consultants updating their project portfolio",
              "Freelancers aiming to land a new contract",
              "Recruiters who want to help their candidates stand out",
            ].map((item, index) => (
              <li
                key={index}
                className="flex text-black items-center gap-4 text-sm md:text-base"
              >
                <img src={tick} alt="Tick" className="w-5 h-5" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div
          className="flex justify-center lg:justify-end w-full lg:w-1/2"
          data-aos="fade-up"
          data-aos-delay="300"
        >
          <img
            className="w-48 h-48 md:w-56 md:h-56 lg:w-[480px] lg:h-[430px]"
            src={image}
            alt="Technical Illustration"
          />
        </div>
      </div>
      {/* Section 4 */}

      <div className="bg-[#FFFFFF] w-full py-8 md:py-16 mt-6">
        <div
          className="flex flex-col items-center text-center px-4 md:px-6"
          data-aos="fade-down-right"
        >
          {/* Heading */}
          <h1 className="text-[#1A5298] font-bold text-xl md:text-2xl lg:text-4xl text-center mb-8 w-full md:w-2/3 lg:w-2/3 xl:w-2/3">
            Ready to Craft Your ServiceNow Story?
          </h1>
          <span className="font-[400] md:text-lg md:w-2/3 lg:w-3/6">
            Let SN Resume Buddy turn your experience into a high-converting resume that tells your true ITSM value.
          </span>
          <span className="font-[400] md:text-lg mt-5">
            Because your skills deserve to be seen!
          </span>
          {/* Button */}
          <Link
            data-aos="zoom-in"
            data-aos-delay="300"
            to={"/contact-us"}
            className="w-[140px] px-6 py-2 md:px-4 md:py-2.5 bg-[#C32A7C] rounded-lg text-white font-bold 
                                         hover:bg-[#F6F6F6] hover:text-[#C32A7C] transition-colors duration-300 text-sm md:text-base 
                                         text-center whitespace-nowrap mt-4 border border-[#C32A7C]"
          >
            Get Started
          </Link>
        </div>
      </div>
    </>
  );
};

export default SnBuddy;
